<lib-toasts></lib-toasts>
<lib-menu-global></lib-menu-global>
<lib-tooltip-global></lib-tooltip-global>
<div [ngClass]="{ hidden: loading() }">
  <router-outlet></router-outlet>
</div>
@if (loading()) {
  <lib-loading class="h-screen flex items-center justify-center"></lib-loading>
}
